<script lang="ts" setup>
import { computed, onMounted } from 'vue'
import Card from 'primevue/card'
import FormSection from '@/components/forms/FormSection.vue'
import FormInputText from '@/components/inputs/FormInputText.vue'
import FormCalendar from '@/components/inputs/FormCalendar.vue'
import Calendar from 'primevue/calendar'
import { formatedDate } from '@/constants'
import { getNextOrderNumber } from '@/api/orders'
import InputText from 'primevue/inputtext'

const props = defineProps<{
  values: any
  type: 'add' | 'edit' | 'view'
  onSubmit: () => void
  setErrors: (errors: any) => void
}>()

const emit = defineEmits(['update:dateReceived', 'update:requiredByDate'])

const isViewPage = computed<boolean>(() => props.type === 'view')
const isAddPage = computed<boolean>(() => props.type === 'add')
</script>

<template>
  <form @submit.prevent="onSubmit" class="border-t border-neutral-200/50 !rounded-t-3xl">
    <Card>
      <template #content>
        <div class="">
          <FormSection title="Order Details" description="">
            <FormInputText
                :viewOnly="isViewPage"
                label="Order Number"
                inputName="orderNumber"
                id="orderNumber"
            />
            <FormCalendar
              :modelValue="values.dateReceived"
              @update:modelValue="$emit('update:dateReceived', $event)"
              :viewOnly="isViewPage"
              label="Date Received"
              inputName="dateReceived"
              id="dateReceived"
            />
            <FormInputText
              :viewOnly="isViewPage"
              label="Order Received Through"
              inputName="submissionMethod"
              id="submissionMethod"
            />
            <FormCalendar
              :modelValue="values.requiredByDate"
              @update:modelValue="$emit('update:requiredByDate', $event)"
              :viewOnly="isViewPage"
              label="Required By Date"
              inputName="requiredByDate"
              id="requiredByDate"
            />
          </FormSection>
        </div>
      </template>
    </Card>
  </form>
</template>
